import script from "./RunsList.vue?vue&type=script&setup=true&lang=js"
export * from "./RunsList.vue?vue&type=script&setup=true&lang=js"

import "./RunsList.vue?vue&type=style&index=0&id=cca86dc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca86dc2"]])

export default __exports__